// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { ContentItemType, ShareMedium, ShareEvent } from "../schema";
import { serialize_ContentItemType_internal, deserialize_ContentItemType_internal } from "./ContentItemType";
import { serialize_ShareMedium_internal, deserialize_ShareMedium_internal } from "./ShareMedium";

export function serialize_ShareEvent_internal(value: ShareEvent): unknown {
  return ((value: { contentItemType: ContentItemType; id: string; shareMedium: ShareMedium }): unknown => {
    return {
      contentItemType: ((value: ContentItemType): unknown => {
        return serialize_ContentItemType_internal(value);
      })(value["contentItemType"]),
      id: ((value: string): unknown => {
        return value;
      })(value["id"]),
      shareMedium: ((value: ShareMedium): unknown => {
        return serialize_ShareMedium_internal(value);
      })(value["shareMedium"]),
    };
  })(value);
}
export function serialize_ShareEvent(obj: ShareEvent): string {
  return renderJsonWithNumbersAsBigint(serialize_ShareEvent_internal(obj));
}
export function deserialize_ShareEvent_internal(value: unknown): ParserResult<ShareEvent> {
  return ((
    value: unknown,
  ): ParserResult<{
    contentItemType: ContentItemType;
    id: string;
    shareMedium: ShareMedium;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/ShareEvent]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/ShareEvent]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "contentItemType")) {
      return { success: false, reason: `[#/components/schemas/ShareEvent/contentItemType]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'contentItemType'.` };
    }
    const parsed_contentItemType = ((): ParserResult<ContentItemType> => {
      return ((value: unknown): ParserResult<ContentItemType> => {
        return deserialize_ContentItemType_internal(value);
      })(value["contentItemType"]);
    })();
    if (!parsed_contentItemType.success) {
      return { success: false, reason: parsed_contentItemType.reason };
    }
    if (!hasProp(value, "id")) {
      return { success: false, reason: `[#/components/schemas/ShareEvent/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
    }
    const parsed_id = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/ShareEvent/id]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["id"]);
    })();
    if (!parsed_id.success) {
      return { success: false, reason: parsed_id.reason };
    }
    if (!hasProp(value, "shareMedium")) {
      return { success: false, reason: `[#/components/schemas/ShareEvent/shareMedium]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'shareMedium'.` };
    }
    const parsed_shareMedium = ((): ParserResult<ShareMedium> => {
      return ((value: unknown): ParserResult<ShareMedium> => {
        return deserialize_ShareMedium_internal(value);
      })(value["shareMedium"]);
    })();
    if (!parsed_shareMedium.success) {
      return { success: false, reason: parsed_shareMedium.reason };
    }
    return { success: true, value: { contentItemType: parsed_contentItemType.value, id: parsed_id.value, shareMedium: parsed_shareMedium.value } };
  })(value);
}
export function deserialize_ShareEvent(str: string): ParserResult<ShareEvent> {
  return deserialize_ShareEvent_internal(parseJsonWithNumbersAsBigint(str));
}
